<template>
	<div>
		<!-- <div class="card panel panel-default actions">
		    <div class="card-block">
		        <div class="header-block clearfix">
		            <button v-on:click="saveRequiredAttributes(requiredAttributes)" class="btn btn-primary pull-right">
						<span v-if="uiStates.showSaving"><i class="fa fa-spinner fa-pulse fa-fw"></i> {{uiStates.saveMessage}}</span>
						<span v-else>{{uiStates.saveMessage}}</span>
		            </button>
		        </div>
		    </div>
		</div> -->
		<transition name="fade">
			<div v-if="uiStates.errorMessage !== ''" class="alert alert-danger ks-solid-light ks-active-border" role="alert">
	            <button type="button" class="close" v-on:click="uiStates.errorMessage = ''">
	                <span aria-hidden="true" class="la la-close"></span>
	            </button>
	            <i class="fa fa-times-circle ks-icon" aria-hidden="true"></i> {{uiStates.errorMessage}}
	        </div>
        </transition>
		<div style="position: relative;">
			<transition name="vue-table-loader">
			    <div class="vue-table-loader alt"v-if="uiStates.showLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
			</transition>
		    <div class="row">
		    	<div class="col-md-6">
		    		<div class="card panel panel-default actions attribute-listing-container">
		    			<div class="card-title no-actions">
		    				<strong>Attributes</strong>
		    				<input @keyup.enter="searchAttributes(searchCriteria)" placeholder="Search..." v-model="searchCriteria" class="form-control attribute-search" type="text">
		    				<button v-on:click="searchAttributes(searchCriteria)" class="seach-icon"><i class="fa fa-search" aria-hidden="true"></i></button>
		    			</div>
	    		       <div class="card-body limit-and-scroll">
		    		       	<transition name="vue-table-loader">
		    		       	    <div class="vue-table-loader alt"v-if="uiStates.showSearchLoading"><span class="fa fa-cog fa-spin fa-3x"></span></div>
		    		       	</transition>
				    		<draggable :options="{group:{ name:'attributes'}}" v-model="attributes">
				    		    <transition-group name="list-complete">
				    		        <div class="attribute-item clearfix" v-for="attribute in attributes" :key="attribute.id">
				    		            <div class="pull-left">
				    		            	<strong>{{attribute.name}}</strong>
				    		            </div>
				    		            <a target="_blank" :href="'/attributes/'+ attribute.id +'/edit'" class="pull-right view-attribute"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
				    		        </div>
				    		    </transition-group>
				    		</draggable>
				    		<div class="search-no-attributes" v-if="attributes.length == 0">
				    			No Attributes Match That Name...
				    		</div>
				    	</div>
				    </div>
		    	</div>
		    	<div class="col-md-6">
		    		<div class="card panel panel-default actions attribute-listing-container">
		    			<div class="card-title no-actions">
		    				<strong>Required Attributes</strong>
		    			</div>
	    		       <div class="card-body limit-and-scroll">
				    		<draggable  class="dragArea" :options="{group:{ name:'attributes'}}" v-model="requiredAttributes">
				    		    <transition-group name="list-complete">
				    		        <div class="attribute-item clearfix" v-for="requiredAttribute in requiredAttributes" :key="requiredAttribute.id">
				    		            <div class="pull-left">
				    		            	<strong>{{requiredAttribute.name}}</strong>
				    		            </div>
				    		            <a target="_blank" :href="'/attributes/'+ requiredAttribute.id +'/edit'" class="pull-right view-attribute"><i class="fa fa-pencil-square-o" aria-hidden="true"></i></a>
				    		        </div>
				    		    </transition-group>
				    		</draggable>
				    		<div class="no-attribute-message" v-if="requiredAttributes.length === 0">Add an Attribute</div>
				    	</div>
				    </div>
		    	</div>
		    </div>
		    <div class="row">
		    	<div class="col-md-12">
		            <button v-on:click="saveRequiredAttributes(requiredAttributes)" class="btn btn-primary ">
						<span v-if="uiStates.showSaving"><i class="fa fa-spinner fa-pulse fa-fw"></i> {{uiStates.saveMessage}}</span>
						<span v-else>{{uiStates.saveMessage}}</span>
		            </button>
		            <a role="button" class="btn btn-secondary" :href="listingUrl">Cancel</a>
		    	</div>
		    </div>
		</div>
	</div>
</template>

<script type="text/javascript">
	var base_url = window.location.protocol + "//" + window.location.host

	import Vue from 'vue';
	import VueEvents from 'vue-events'
	import draggable from 'vuedraggable'
	import axios from 'axios'


	Vue.use(VueEvents)

	export default {
	    name: 'workflow-required-attributes',
	    props: ['WorkflowId'],
	    components:{
			draggable,
	    },
	    data() {
	    	return {
	    		uiStates: {
					showLoading: false,
					showSearchLoading: false,
					showSaving: false,
					saveMessage: 'Save Required Attributes',
					errorMessage: '',
					createDisplayGroupVisible: true,
	    		},
                searchCriteria: '',
	    		currentWorkflowId: this.WorkflowId,
	    		listingUrl: base_url + '/workflow',
	    		attributes: [],
	    		requiredAttributes: [],
			}
	    },
	    mounted() {

	    },
	    created() {
			this.loadAttributes(this.searchCriteria);
            this.loadRequiredAttributes();
        },
	    watch: {
			requiredAttributes: {
                handler(newValue, oldValue) {
                	this.uiStates.saveMessage = 'Save Required Attributes';
                },
                deep: true
            },
	    },
	    methods: {
            onMove: function(evt, originalEvent) {
            	console.log('Moving: ' + evt.draggedContext.element.name + '(' + evt.draggedContext.element.id+')');
			},
            saveRequiredAttributes: function (requiredAttributes) {
            	this.uiStates.showSaving = true;
            	this.uiStates.showLoading = true;
            	this.uiStates.saveMessage = 'Saving...';

                axios.post('/workflow/' + this.currentWorkflowId + '/save-required-attributes', {
                   'requiredAttributes': requiredAttributes,
               })
               .then(function (response) {
                   	this.uiStates.showSaving = false;
                    this.uiStates.saveMessage = 'Required Attributes Saved!';
                    this.loadAttributes(this.searchCriteria);
                    this.loadRequiredAttributes();
                    this.uiStates.showLoading = false;
               }.bind(this))
               .catch(function (error) {
                   this.uiStates.showSaving = false;
                   this.uiStates.errorMessage = 'An error has occured!';
                   this.uiStates.saveMessage = 'Save Required Attributes';
               }.bind(this));
            },
            loadAttributes: function (criteria) {
            	this.uiStates.showLoading = true;

                axios.post('/workflow/' + this.currentWorkflowId + '/get-attribute-listing', {
                    'criteria': criteria
                })
                .then(function (response) {
            		this.uiStates.showLoading = false;
            	    this.attributes = response.data;
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.showLoading = false;
                    this.uiStates.errorMessage = 'An error has occured!';
                }.bind(this));
            },
            loadRequiredAttributes: function () {
                axios.post('/workflow/' + this.currentWorkflowId +'/get-required-attributes', {})
                .then(function (response) {
            	    this.requiredAttributes = Object.values(response.data);
                }.bind(this))
                .catch(function (error) {
                    this.uiStates.errorMessage = 'An error has occured!';
                }.bind(this));
            },
            searchAttributes: function (criteria) {
            	this.uiStates.showSearchLoading = true;
                axios.post('/workflow/' + this.currentWorkflowId + '/get-attribute-listing', {
                    'criteria': criteria
                })
				.then(function (response) {
					this.attributes = response.data;
					this.uiStates.showSearchLoading = false;
				}.bind(this))
				.catch(function (error) {
				    console.log('Error with search');
				    this.uiStates.showSearchLoading = false;
				}.bind(this));
            },

		}
	};
</script>

<style scoped lang="scss">
	.vue-table-loader.alt{
		padding-top: 20px;
	}
	.attribute-item{
		background-color: #fff;
		border:solid 1px #dee0e1;
		padding: 10px;
		margin-bottom: -1px;
	}
	.card-title{
		position: relative;
		border-bottom:solid 1px #dee0e1;
		padding: 14px 20px 10px 20px;
		margin-bottom: 0px;
		min-height: 45px;
		.copy{
			transition: color 0.4s;
		}
		&.editable-group{
			padding: 10px 70px 10px 20px;
		}
		&.no-action{
			padding: 12px 20px;
		}
	}
	.card-body{
		position: relative;
		transition: max-height 0.7s;
		&.limit-and-scroll{
			max-height:600px;
			overflow-y: auto;
			&::-webkit-scrollbar {
			    width: 4px;
			}
			&::-webkit-scrollbar-track {
			    background: rgba(0,0,0,0.1);
			    position: absolute;
			    top: 0px;
			    bottom: 0px;
			    right: 0px;
			}
			&::-webkit-scrollbar-thumb {
			    background: #909090;
			    border-radius:2px;
			}
			&::-webkit-scrollbar-thumb:hover {
			    background: #909090;
			}
		}
	}
	.view-attribute{
		font-size:18px;
		color: #c3c6ca;
		line-height: 19px;
	}
	.dragArea{
		position: relative;
		z-index: 2;
		min-height: 44px;
		span{
			min-height: 44px;
			display: block;
		}
	}
	.no-attribute-message{
		padding: 11px;
		position: absolute;
		z-index: 1;
		top: 20px;
		left: 20px;
		right: 20px;
		color: #bbbbbb;
		border:1px dashed #d8dadc;
		text-align: center;
	}
	.attribute-search{
		position: absolute;
		top: -1px;
		right: -1px;
		bottom: -1px;
		width: 220px;
		height: 46px;
	}
	.search-no-attributes{
		padding: 15px 10px;
		text-align: center;
		color: #b2b2b2;
	}
	.seach-icon{
		position: absolute;
	    top: 5px;
	    right: 0px;
	    bottom: 5px;
	    color: #d8dadc;
	    font-size: 13px;
	    font-size: 18px;
	    cursor: pointer;
	    border: 0;
	    padding: 0px 15px;
	    border-left: 1px solid #dedede;
	    background-color: white;
	}
	.fade-enter-active, .fade-leave-active {
        transition: opacity .3s;
    }
    .fade-enter, .fade-leave-to{
        opacity: 0;
    }
    .attribute-listing-container{
    	margin-bottom: 0px;
    }
</style>